const messages = {
    accountBox: {
        title: "Panel de control",
        description: "Siga rápidamente sus promociones y puntos.",
        button: "ABRIR PANEL DE CONTROL",
    },
};

export default {
    messages,
};
